// Steps Block - Step-by-step guide
class StepsBlock {
  static get toolbox() {
    return {
      title: 'Steps',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>'
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, config, api, readOnly }) {
    this.data = {
      steps: data.steps || [
        { title: 'Step 1', description: '' }
      ]
    };
    this.readOnly = readOnly;
    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement('div');
    this._render();
    return this.wrapper;
  }

  _render() {
    this.wrapper.innerHTML = `
      <div class="steps-block space-y-4" data-testid="steps-block">
        ${this.data.steps.map((step, idx) => `
          <div class="flex gap-4 step-item" data-index="${idx}">
            <div class="flex flex-col items-center">
              <div class="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center font-semibold text-sm">${idx + 1}</div>
              ${idx < this.data.steps.length - 1 ? '<div class="flex-1 w-0.5 bg-blue-200 dark:bg-blue-800 mt-2"></div>' : ''}
            </div>
            <div class="flex-1 pb-4">
              <div class="step-title font-semibold text-slate-900 dark:text-white mb-1" contenteditable="${!this.readOnly}" data-placeholder="Step title">${step.title}</div>
              <div class="step-desc text-sm text-slate-600 dark:text-slate-400" contenteditable="${!this.readOnly}" data-placeholder="Description...">${step.description}</div>
              ${!this.readOnly && this.data.steps.length > 1 ? `
                <button class="remove-step mt-2 text-xs text-red-500 hover:underline" data-index="${idx}">Remove step</button>
              ` : ''}
            </div>
          </div>
        `).join('')}
        ${!this.readOnly ? `
          <button class="add-step flex items-center gap-2 text-sm text-blue-600 dark:text-blue-400 hover:underline">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            Add step
          </button>
        ` : ''}
      </div>
    `;

    if (!this.readOnly) {
      this.wrapper.querySelectorAll('.step-title').forEach((el, idx) => {
        el.addEventListener('input', (e) => {
          this.data.steps[idx].title = e.target.textContent;
        });
      });
      this.wrapper.querySelectorAll('.step-desc').forEach((el, idx) => {
        el.addEventListener('input', (e) => {
          this.data.steps[idx].description = e.target.innerHTML;
        });
      });
      this.wrapper.querySelector('.add-step')?.addEventListener('click', () => {
        this.data.steps.push({ title: `Step ${this.data.steps.length + 1}`, description: '' });
        this._render();
      });
      this.wrapper.querySelectorAll('.remove-step').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const idx = parseInt(e.target.dataset.index);
          this.data.steps.splice(idx, 1);
          this._render();
        });
      });
    }
  }

  save() {
    return this.data;
  }
}

export default StepsBlock;
